module.exports = __webpack_public_path__ + "static/img/mind_control_main.48c21c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/main/products/mind_control_main.png
// module id = Gpi8
// module chunks = 1